import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";
import classes from "./BrainstormingStep.module.scss";
import QuestionInput from "../QuestionInput/QuestionInput";
import QuestionTextArea from "../QuestionTextArea/QuestionTextArea";
import CharactersSection from "../CharactersSection/CharactersSection";

const BrainstormingStep = ({
  storyWhereWhen,
  character1Name,
  character1Age,
  character1About,
  character2Name,
  character2Age,
  character2About,
  character3Name,
  character3Age,
  character3About,
  storyProblem,
  storySolution,
}) => {
  return (
    <div className={cs(classes.brainstormingStep)}>
      <h2 className={cs(classes.heading, classes.grandstanderFamily)}>
        Brainstorming Time
      </h2>

      <div className={cs(classes.guidingPrompt)}>
        <p className={cs(classes.promptText)}>
         <b> Think:</b> How can I bring this idea out in a story?
        </p>
        <p className={cs(classes.promptText)}>
          How do I make it interesting? Should I make it dramatic? Emotional?
        </p>
        <p className={cs(classes.promptText, classes.flowText, "mt-05")}>
         <b> Sit back and let your imagination flow! </b>
        </p>
      </div>

      <div className={cs(classes.formSection)}>
        <QuestionInput
          id="story-where-when"
          label="Where and when is your story happening?"
          value={storyWhereWhen.value}
          onChange={storyWhereWhen.onChange}
          placeholder="Short Answer text"
          error={storyWhereWhen.error}
          required={true}
        />

        <CharactersSection
          character1Name={character1Name}
          character1Age={character1Age}
          character1About={character1About}
          character2Name={character2Name}
          character2Age={character2Age}
          character2About={character2About}
          character3Name={character3Name}
          character3Age={character3Age}
          character3About={character3About}
        />

        <QuestionTextArea
          id="story-problem"
          label="What is the big problem or challenge the characters face?"
          value={storyProblem.value}
          onChange={storyProblem.onChange}
          placeholder="Long Answer text"
          error={storyProblem.error}
          required={true}
          rows={3}
        />

        <QuestionTextArea
          id="story-solution"
          label="How does the lesson from the poussk help them solve it?"
          value={storySolution.value}
          onChange={storySolution.onChange}
          placeholder="Long Answer text"
          error={storySolution.error}
          required={true}
          rows={3}
        />
      </div>
    </div>
  );
};

const inputPropTypes = PropTypes.shape({
  value: PropTypes.string.isRequired,
  error: PropTypes.string,
  onChange: PropTypes.func.isRequired,
});

BrainstormingStep.propTypes = {
  storyWhereWhen: inputPropTypes.isRequired,
  character1Name: inputPropTypes.isRequired,
  character1Age: inputPropTypes.isRequired,
  character1About: inputPropTypes.isRequired,
  character2Name: inputPropTypes.isRequired,
  character2Age: inputPropTypes.isRequired,
  character2About: inputPropTypes.isRequired,
  character3Name: inputPropTypes.isRequired,
  character3Age: inputPropTypes.isRequired,
  character3About: inputPropTypes.isRequired,
  storyProblem: inputPropTypes.isRequired,
  storySolution: inputPropTypes.isRequired,
  errorMessage: PropTypes.string,
};

export default BrainstormingStep;

